export enum QueryParams {
  Branch = 'branch',
  Table = 'table',
  StartRowId = 'startRowId',
  EndRowId = 'endRowId',
  Columns = 'columns',
}
